<template>
  <b-modal
    id="sale-office-modal"
    cancel-variant="outline-secondary"
    :ok-title="isEdit ? $t('generals.save') : $t('generals.create')"
    :cancel-title="$t('generals.cancel')"
    centered
    no-close-on-backdrop
    :title="isEdit ? $t('references.edit_office'): $t('references.add_office')"
    size="xl"
    @ok="saveClick"
  >
    <!-- @hidden="form_obj = def_form_obj" -->
    <b-row>
      <b-col md="6">
        <leaflet-map
          :position="{lat: form_obj.latitude, lng: form_obj.longitude}"
          @position="setPosition"
        />
      </b-col>
      <b-col
        md="6"
      >
        <validation-observer ref="officeValidations">
          <validated-form
            :form_fields="getFormFields"
            :def_form_obj="form_obj"
            @field_update="form => form_obj = form"
          />
        </validation-observer>
        <b-img
          v-if="form_obj.image"
          thumbnail
          width="320"
          :src="getImage"
        />
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import {
  BModal, BRow, BCol, BImg,
} from 'bootstrap-vue'
import { mapActions } from 'vuex'
import {
  ValidationObserver,
  // ValidationProvider
} from 'vee-validate'
import validatedForm from '@/components/validatedForm.vue'
import leafletMap from '@/components/map.vue'
import formatters from '@/mixins/extra'

export default {
  components: {
    BModal,
    validatedForm,
    ValidationObserver,
    leafletMap,
    BRow,
    BCol,
    BImg,
  },
  mixins: [formatters],
  props: {
    isEdit: {
      type: Boolean,
      required: false,
      default: false,
    },
    defFormObj: {
      type: Object,
      required: false,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      form_obj: {},
      image_preview: '',
    }
  },
  computed: {
    getFormFields() {
      return [
        {
          obj_name: 'title',
          label: this.$t('references.title'),
        },
        {
          obj_name: 'address',
          label: this.$t('references.address'),
        },
        {
          obj_name: 'work_hours_start',
          col_size: 6,
          component_name: 'flat-pickr',
          label: this.$t('references.begin_work_day'),
          props: {
            class: 'form-control',
            config: {
              enableTime: true,
              noCalendar: true,
              dateFormat: 'H:i',
              time_24hr: true,
            },
          },
        },
        {
          obj_name: 'work_hours_end',
          col_size: 6,
          component_name: 'flat-pickr',
          label: this.$t('references.end_work_day'),
          props: {
            class: 'form-control',
            config: {
              enableTime: true,
              noCalendar: true,
              dateFormat: 'H:i',
              time_24hr: true,
            },
          },
        },
        {
          obj_name: 'image',
          component_name: 'b-form-file',
          placeholder: this.$t('references.upload_file'),
          label: this.$t('references.photo'),
          props: {
            accept: 'image/*',
            'browse-text': this.$t('references.upload'),
          },
        },
      ]
    },
    getImage() {
      if (('url' in this.form_obj.image) && this.form_obj.image !== null) {
        return this.form_obj.image.url
      }
      return this.image_preview
    },
  },
  watch: {
    defFormObj() {
      this.form_obj = this.defFormObj
    },
    'form_obj.image': async function (newVal) {
      this.image_preview = await this.$_convertToBase64(newVal)
    },
  },
  mounted() {
    this.form_obj = this.defFormObj
  },
  methods: {
    ...mapActions('knowledgeBase', ['CREATE_SALE_OFFICE', 'EDIT_SALE_OFFICE']),
    saveClick(bvModal) {
      bvModal.preventDefault()
      this.$refs.officeValidations.validate().then(success => {
        if (success) {
          console.log(this.form_obj)
          if (!(this.form_obj.image instanceof File)) {
            this.$delete(this.form_obj, 'image')
          }
          const fd = new FormData()
          Object.keys(this.form_obj).forEach(el => {
            fd.append(el, this.form_obj[el])
          })
          if (this.isEdit) {
            this.EDIT_SALE_OFFICE(fd).then(() => {
              this.$emit('addSuccess')
              this.$bvModal.hide('sale-office-modal')
              this.$_successToast(this.$t('generals.changed'))
            }).catch(() => {
              this.$_errorToast('Ошибка')
            })
          } else {
            this.CREATE_SALE_OFFICE(fd).then(() => {
              this.$emit('addSuccess')
              this.$bvModal.hide('sale-office-modal')
              this.$_successToast(this.$t('generals.added'))
            }).catch(() => {
              this.$_errorToast(this.$t('generals.error'))
            })
          }
        }
      })
    },
    setPosition(pos) {
      this.form_obj.latitude = pos.lat
      this.form_obj.longitude = pos.lng
    },
  },
}
</script>

<style></style>
